import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="duration-picker"
export default class extends Controller {
  static targets = ['modal', 'input', 'dummy', 'durationBtn']

  connect() {
  }

  close() {
    this.modalTarget.classList.remove('open')
  }

  open(){
    this.modalTarget.classList.add('open')
  }

  select(event) {
    this.durationBtnTargets.forEach(button => {
      button.classList.remove('active')
    })
    event.currentTarget.classList.add('active')
    this.inputTarget.value = event.currentTarget.dataset.value
    this.dummyTarget.innerText = event.currentTarget.innerText
  }
}
